"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PriceTierSchema = void 0;
const zod_1 = require("zod");
const currency_amount_1 = require("./currency-amount");
exports.PriceTierSchema = zod_1.z.object({
  id: zod_1.z.number(),
  currencyAmounts: zod_1.z.array(currency_amount_1.CurrencyAmountSchema),
  is_enabled: zod_1.z.boolean().default(true),
  created_at: zod_1.z.string().datetime().or(zod_1.z.date()).or(zod_1.z.null()).optional(),
  updated_at: zod_1.z.string().datetime().or(zod_1.z.date()).or(zod_1.z.null()).optional()
});
